<template>
  <a-card :bordered="false">
    <div class="con">
      <div class="head">
        <div class="card-title">培训内容</div>
        <a-button v-action:pxnr_add style="margin-bottom: 12px" type="primary" icon="plus" @click="handleAdd">新增培训内容</a-button>
        <a-input-search
            allowClear
            v-model="queryParam.keyword"
            placeholder="请输入标题"
            @search="onSearch"
        />
      </div>
      <div style="margin: 5px 0"></div>
      <div class="main">
        <a-spin :spinning="confirmLoading">
          <div class="list" v-if="list.length">
            <div @click="setActionVehicle(item)"
                 :class="['list-item',actionVehicle.train_id==item.train_id?'action':'']" v-for="item in list">
              <div>{{ item.train_title }}</div>
              <div>
                <a-tooltip v-action:pxnr_edit placement="top">
                  <template slot="title">
                    <span>编辑</span>
                  </template>
                  <a-icon type="edit" @click="handleEdit(item)" style="margin-right: 5px"/>
                </a-tooltip>

                <a-tooltip v-action:pxnr_delete placement="top">
                  <template slot="title">
                    <span>删除</span>
                  </template>
                  <a-popconfirm
                      title="确认删除当前记录？"
                      ok-text="确定"
                      cancel-text="取消"
                      @confirm="handleDelete(item)"
                  >
                    <a-icon type="delete"/>
                  </a-popconfirm>
                </a-tooltip>
              </div>
            </div>
          </div>
          <a-empty v-else/>
        </a-spin>
      </div>
    </div>
    <SaveForm ref="SaveForm" @handleSubmit="getList"/>
  </a-card>
</template>
<script>
import * as Api from '@/api/train/regularTrain'
import SaveForm from "./modules/SaveForm";

export default {
  components: {SaveForm},
  data() {
    return {
      queryParam: {
        keyword: ''
      },
      list: [],
      actionVehicle: {},
      confirmLoading: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    /**
     * 新增记录
     */
    handleAdd() {
      this.$refs.SaveForm.add()
    },

    /**
     * 编辑记录
     */
    handleEdit(item) {
      this.$refs.SaveForm.edit(item)
    },

    handleDelete(item) {
      Api.deleted({train_id: item['train_id']})
          .then((result) => {
            this.$message.success(result.message, 1.5)
            this.getList()
          })
    },

    handlePreview(url) {
      window.open('http://view.officeapps.live.com/op/view.aspx?src=' + url)
    },

    async getList() {
      this.confirmLoading = true
      const {data: {list}} = await Api.all(this.queryParam)
      this.list = list
      this.confirmLoading = false
    },
    onSearch(e) {
      this.getList()
    },
    setActionVehicle(item) {
      this.actionVehicle = item
      this.$emit('success', this.actionVehicle)
    }
  },
}

</script>
<style scoped lang="less">
.con {
  height: calc(100vh - 140px);
  background: #FFFFFF;
  flex-direction: column;
  display: flex;
}

.head {
  flex-grow: 1;
}

.main {
  height: 100%;
  flex-grow: 1;
  overflow: scroll;
}

.list {
  border: 1px solid #e8e8e8;

  .list-item {
    font-weight: bold;
    border-bottom: 1px solid #e8e8e8;
    padding: 8px;
    cursor: pointer;
    transition: all .3s;
    display: flex;
    justify-content: space-between;

    &:hover {
      background: #f4f4f4;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .action {
    background: #378DDB !important;
    color: #FFFFFF;
  }
}
</style>
